import { WppIconDrag } from '@platform-ui-kit/components-library-react'
import { AppInstanceShort } from '@wpp-open/core'
import clsx from 'clsx'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'

import { Flex } from 'components/common/flex/Flex'
import styles from 'pages/admin/hierarchy/hierarchyView/appsHierarchyColumn/AppsHierarchyColumn.module.scss'
import { useReorderAppInstancesShort } from 'pages/admin/hierarchy/hierarchyView/appsHierarchyColumn/utils'

interface Props {
  isDraggableActiveParent?: boolean
  appInstances: AppInstanceShort[]
  isManageAppsDisabled: boolean
  renderApp: (appInstance: AppInstanceShort, i: number, source: AppInstanceShort[]) => JSX.Element
  droppableType: string
  droppableId: string
}

export const DraggableAppInstances = ({
  isDraggableActiveParent,
  appInstances,
  isManageAppsDisabled,
  renderApp,
  droppableType,
  droppableId,
}: Props) => {
  const { ordered, onDragEnd } = useReorderAppInstancesShort(appInstances)

  return (
    <>
      {!!ordered.length && (
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable key={droppableId} droppableId={droppableId} type={droppableType}>
            {provided => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                <Flex
                  className={clsx({
                    [styles.draggableGroupApps]: ordered.length > 1 && isDraggableActiveParent,
                  })}
                  direction="column"
                  gap={2}
                  data-testid={`${droppableId}-apps`}
                >
                  {ordered.map((appInstance, i) => (
                    <Draggable
                      key={appInstance.id}
                      draggableId={appInstance.id}
                      isDragDisabled={isManageAppsDisabled || ordered.length === 1}
                      index={i}
                    >
                      {(draggableProvided, draggableSnapshot) => {
                        return (
                          <Flex
                            ref={draggableProvided.innerRef}
                            {...draggableProvided.draggableProps}
                            style={{
                              ...draggableProvided.draggableProps.style,
                            }}
                            className={clsx({
                              [styles.isDragging]: draggableSnapshot.isDragging,
                              [styles.draggableItem]: isManageAppsDisabled || ordered.length > 1,
                            })}
                            align="center"
                            justify="between"
                            gap={5}
                            data-testid={`app-instance-${i}`}
                          >
                            {!isManageAppsDisabled && ordered.length != 1 && (
                              <Flex className={styles.dragIconWrapper}>
                                <WppIconDrag
                                  {...draggableProvided.dragHandleProps}
                                  className={styles.dragIcon}
                                  data-testid={`app-instance-${i}-drag-icon`}
                                />
                              </Flex>
                            )}
                            <>{renderApp(appInstance, i, appInstances)}</>
                          </Flex>
                        )
                      }}
                    </Draggable>
                  ))}
                </Flex>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </>
  )
}
